module.exports = __webpack_public_path__ + "static/product3-a-34c8b97a764b5a682864dacd75f24c42.png";